import http from '@/lib/http';

export default {
    queryHealthRecord() {
        return http({
            url: `/manageService/queryHealthRecord`
        });
    },
    saveHealthRecord({
        id,
        name,
        relation,
        idCard,
        gender,
        birthDate,
        phone,
        height,
        weight,
        bloodType,
        isDefault,
        pastHistory,
        allergyHistory,
        familyHistory,
        personalHabits
    } = {}) {
      
        return http({
            url: `/manageService/saveHealthRecord`,
            data: {
                id,
                name,
                relation,
                idCard,
                gender,
                birthDate,
                phone,
                height,
                weight,
                bloodType,
                isDefault,
                pastHistory,
                allergyHistory,
                familyHistory,
                personalHabits
            }
        });
    },
    changeHealthRecordDefault(id) {
        return http({
            url: `/manageService/changeHealthRecordDefault/${id}`
        });
    },
    getHealthRecord(recordId){
        return http({
            url: `/manageService/getHealthRecord/${recordId}`
        });
    },
    getHealthRecordByCardNo(cardNo){
        return http({
            url: `/manageService/getHealthRecordByCardNo/${cardNo}`
        });
    },
    removeHealthRecord(id) {
        return http({
            url: `/manageService/removeHealthRecord/${id}`
        });
    },
    getDefaultHealthRecord() {
        return http({
            url: `/manageService/getDefaultHealthRecord`
        });
    },
    saveUserAddress({
        id,
        name,
        phone,
        addressDetail,
        postalCode,
        isDefault,
        address,
        latitude,
        longitude,
        organId
    } = {}) {
        return http({
            url: `/manageService/saveUserAddress`,
            data: {
                id,
                name,
                phone,
                addressDetail,
                postalCode,
                isDefault,
                address,
                latitude,
                longitude,
                organId
            }
        });
    },
    queryUserAddress(organId) {
        return http({
            url: `/manageService/queryUserAddress/${organId}`
        });
    },
    getUserAddress(id) {
        return http({
            url: `/manageService/getUserAddress/${id}`
        });
    },
    delUserAddress(id) {
        return http({
            url: `/manageService/delUserAddress/${id}`
        });
    },
    queryMedicalRecord(type, organCode) {
        return http({
            url: `/manageService/queryMedicalRecord/${type}/${organCode}`
        });
    },
    submitMedicalEvaluation({ medicalRecordId, content, point } = {}) {
        return http({
            url: `/manageService/submitMedicalEvaluation`,
            data: { medicalRecordId, content, point }
        });
    },
    getCaseHistory(medicalRecordId) {
        return http({
            url: `/manageService/getCaseHistory/${medicalRecordId}`
        });
    },
    queryPrescription() {
        return http({
            url: `/manageService/queryPrescription`
        });
    },
    queryByPrescription(medicalRecordId) {
        return http({
            url: `/manageService/queryByPrescription/${medicalRecordId}`
        });
    },
    viewPrescription(prescriptionId) {
        return http({
            url: `/manageService/viewPrescription/${prescriptionId}`
        });
    },
    queryMedicalOrder(page, limit, type, organCode) {
        return http({
            url: `/manageService/queryMedicalOrder/${page}/${limit}?type=${type}&organCode=${organCode}`
        });
    },
    queryByMedicalRecord(idCard, organCode) {
        return http({
            url: `/manageService/queryByMedicalRecord/${idCard}/${organCode}`
        });
    },
    saveDrugDelivery(data = {}) {
        return http({
            url: `/manageService/saveDrugDelivery`,
            data: data
        });
    },
    queryDrugDelivery(data = {}) {
        return http({
            url: `/manageService/queryDrugDelivery`,
            data: data
        });
    },
    
}
